module.exports = __webpack_public_path__ + "static/media/simulationattack.83292439.png";